/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FishInputs */

const en_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fish`)
};

const es_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pez`)
};

const fr_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poisson`)
};

const de_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fisch`)
};

const ja_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`魚`)
};

const zh_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鱼类`)
};

const ar_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسماك`)
};

const id_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikan`)
};

const it_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesce`)
};

const ru_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рыбы`)
};

const pt_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peixe`)
};

const ko_val_fish = /** @type {(inputs: Val_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`물고기`)
};

/**
* | output |
* | --- |
* | "Fish" |
*
* @param {Val_FishInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_fish = /** @type {((inputs?: Val_FishInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FishInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_fish(inputs)
	if (locale === "es") return es_val_fish(inputs)
	if (locale === "fr") return fr_val_fish(inputs)
	if (locale === "de") return de_val_fish(inputs)
	if (locale === "ja") return ja_val_fish(inputs)
	if (locale === "zh") return zh_val_fish(inputs)
	if (locale === "ar") return ar_val_fish(inputs)
	if (locale === "id") return id_val_fish(inputs)
	if (locale === "it") return it_val_fish(inputs)
	if (locale === "ru") return ru_val_fish(inputs)
	if (locale === "pt") return pt_val_fish(inputs)
	return ko_val_fish(inputs)
});